import React, { useEffect, useState } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { PortalButton } from './PortalElements';

function SidebarLink({ item, onNavigate }) {
  return (
    <NavLink
      to={item.href}
      onClick={onNavigate}
      className={({ isActive }) =>
        `portal-nav-link ${isActive ? 'portal-nav-link-active' : ''}`.trim()
      }
    >
      <span>{item.label}</span>
    </NavLink>
  );
}

export default function PortalLayout({
  title,
  subtitle,
  items,
  children,
  onLogout,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  async function handleLogout() {
    await onLogout();
    navigate('/');
  }

  function renderSidebar(isMobile = false) {
    return (
      <>
        <div className="portal-sidebar-top">
          <p className="portal-kicker">Karali</p>
          <h1 className="portal-title">{title}</h1>
          <p className="portal-subtitle">{subtitle}</p>
        </div>
        <nav className="portal-nav">
          {items.map((item) => (
            <SidebarLink
              key={item.href}
              item={item}
              onNavigate={isMobile ? () => setMenuOpen(false) : undefined}
            />
          ))}
        </nav>
        <PortalButton variant="secondary" onClick={handleLogout}>
          Logout
        </PortalButton>
      </>
    );
  }

  return (
    <main className="portal-shell">
      <aside className="portal-sidebar portal-sidebar-desktop">
        {renderSidebar()}
      </aside>

      <div className="portal-mobile-bar">
        <div>
          <p className="portal-kicker">Karali</p>
          <div className="portal-mobile-title">{title}</div>
        </div>
        <button
          type="button"
          className="portal-menu-button"
          onClick={() => setMenuOpen((current) => !current)}
          aria-label={menuOpen ? 'Close navigation menu' : 'Open navigation menu'}
          aria-expanded={menuOpen}
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      {menuOpen ? (
        <div className="portal-mobile-overlay" onClick={() => setMenuOpen(false)}>
          <aside
            className="portal-sidebar portal-sidebar-mobile"
            onClick={(event) => event.stopPropagation()}
          >
            {renderSidebar(true)}
          </aside>
        </div>
      ) : null}

      <section className="portal-content">
        <div className="portal-content-inner">{children}</div>
      </section>
    </main>
  );
}
